function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 380;


//////////////////
// WEBPACK FOOTER
// ./~/mapnik-reference
// module id = 380
// module chunks = 0 1 5